import { render, staticRenderFns } from "./CerrarSorteo.vue?vue&type=template&id=7538d6c8&dark=true"
import script from "./CerrarSorteo.vue?vue&type=script&lang=js"
export * from "./CerrarSorteo.vue?vue&type=script&lang=js"
import style0 from "./CerrarSorteo.vue?vue&type=style&index=0&id=7538d6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports